module.exports = __webpack_public_path__ + "img/severin-candrian-unsplash-300.1566d7c7.jpg";